import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import {
    Box,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Tooltip,
    Divider,
} from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import BarChartIcon from '@mui/icons-material/BarChart'
import PeopleIcon from '@mui/icons-material/People'
import Diversity3Icon from '@mui/icons-material/Diversity3'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import MenuIcon from '@mui/icons-material/Menu'
import { RotatingHeader } from './header'

export const Sidebar = () => {
    const [collapsed, setCollapsed] = useState(false)

    const handleToggle = () => {
        if (collapsed) {
            setCollapsed(false)
        } else {
            setCollapsed(true)
        }
    }

    const navItems = [
        { icon: <HomeIcon />, label: 'Home', to: '/' },
        { icon: <PeopleIcon />, label: 'Players', to: '/player' },
        { icon: <BarChartIcon />, label: 'Statistics', to: '/statistics' },
        { icon: <Diversity3Icon />, label: 'Synergy', to: '/synergy' },
    ]

    return (
        <Box
            sx={{
                width: collapsed ? 72 : 300,
                backgroundColor: '#161b22',
                color: '#ffffff',
                p: 2,
                height: '100vh',
                position: 'sticky',
                top: 0,
                transition: 'width 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <RotatingHeader collapsed={collapsed} />

                <IconButton
                    onClick={handleToggle}
                    sx={{ color: '#ffffff', alignSelf: 'center' }}
                >
                    {collapsed ? <MenuIcon /> : <MenuOpenIcon />}
                </IconButton>
            </Box>

            <Divider sx={{ borderColor: '#30363d' }} />

            <List>
                {navItems.map((item, index) => (
                    <Tooltip
                        key={item.label}
                        title={collapsed ? item.label : ''}
                        placement="right"
                        arrow
                    >
                        <ListItemButton component={Link} to={item.to} sx={{ color: 'inherit', width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <ListItemIcon sx={{ color: 'inherit', minWidth: 0, mr: collapsed ? 0 : 1 }}>
                                {item.icon}
                            </ListItemIcon>
                            {!collapsed && <ListItemText
                                primary={item.label}
                                sx={{
                                    animation: 'slideUpFade 0.3s ease',
                                    animationDelay: `${index * 250}ms`,
                                    animationFillMode: 'forwards',
                                    opacity: 0,
                                    '@keyframes slideUpFade': {
                                        from: { opacity: 0, transform: 'translateY(10px)' },
                                        to: { opacity: 1, transform: 'translateY(0)' },
                                    }
                                }}
                            />}
                        </ListItemButton>
                    </Tooltip>
                ))}
            </List>
        </Box>
    )
}
